module.exports = __webpack_public_path__ + "img/035-minus.82d2d430.svg";